import { matchPath, useLocation } from 'react-router';

// ----------------------------------------------------------------------

type ReturnType = boolean;

export function useActiveLink(
  regex: RegExp | null,
  path: string,
  deep = true,
): ReturnType {
  const { pathname } = useLocation();

  if (regex) {
    return !!pathname.match(regex);
  }

  const normalActive = path
    ? !!matchPath({ path, end: true }, pathname)
    : false;

  const deepActive = path ? !!matchPath({ path, end: false }, pathname) : false;

  return deep ? deepActive : normalActive;
}
